import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';

function Form() {
    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const profileFilter = chooseProfileFilter();

    const { id } = useParams();

    const path = '/governanceroom/observatories/';
    const endpointBackend = config.endpoints.backend
    const paths = {
        endpointSave: endpointBackend + 'governanceroom/observatories/save',
        endpointGetById: endpointBackend + 'governanceroom/observatories/getById',
        endpointGetOneObservatory: endpointBackend + 'governanceroom/observatories/getone',
        endpointGetAllClients: endpointBackend + 'governanceroom/clients/getall',
        endpointGetAllObservatoryCities: endpointBackend + 'governanceroom/observatorycities/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Novo Observatório",
        labelTitleEdit: "Editar Observatório",
        labelTitleView: 'Visualizar Observatório'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            fields: [
                {
                    name: 'name',
                    type: 'text',
                    label: 'Nome - Observatório',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'governance_room_client_id',
                    type: 'select',
                    label: 'Cliente',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllClients,
                        label: 'company_name',
                        value: 'governance_room_client_id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'observatory_cities',
                    type: 'multiinput',
                    label: 'Municípios',
                    sortBy: 'index',
                    showDeleteButton: true,
                    form: [
                        {
                            name: 'governance_room_observatory_city_id',
                            type: 'select',
                            label: 'Município',
                            options: [],
                            optionsEndpoint: {
                                endpoint: paths.endpointGetAllObservatoryCities,
                                label: 'client_city_name',
                                value: 'id',
                                params: {
                                    filter: {
                                        ...profileFilter
                                    }
                                }
                            },
                            validations: {
                                required: false
                            }
                        },
                    ],
                    validations: {
                        required: false
                    },
                    columnSize: 12,
                },
                {
                    name: 'portal_url',
                    type: 'text',
                    label: 'URL Amigável',
                    validations: {
                        required: true,
                        verifyFriendlyUrl: true
                    },
                    columnSize: 12
                },
                {
                    name: "custom_about",
                    type: "richText",
                    label: "Sobre",
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: "custom_methodology",
                    type: "richText",
                    label: "Metodologia",
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: "logo",
                    type: "file",
                    label: "Logo (Sugestão: 100x40)",
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: "title",
                    type: "text",
                    label: "Título",
                    validations: {
                        required: true
                    },
                    columnSize: 6
                },
                {
                    name: "subtitle",
                    type: "text",
                    label: "Subtítulo",
                    validations: {
                        required: true
                    },
                    columnSize: 6
                },
                {
                    name: "banner",
                    type: "file",
                    label: "Banner (Sugestão: 1280x720)",
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            customValidators: {
                verifyFriendlyUrl: async (value, options, key, attributes) => {
                    if (attributes.portal_url) {
                        const verifyData = await Fetch.post(paths.endpointGetOneObservatory, {
                            filter: {
                                portal_url: attributes.portal_url,
                                deleted: '0'
                            }
                        })

                        if (
                            verifyData &&
                            verifyData.portal_url == attributes.portal_url &&
                            verifyData.id != id
                        ) {
                            return '^ Já existe uma entidade com essa URL.';
                        } else {
                            return '';
                        }
                    } else {
                        return '';
                    }
                }
            },
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
